/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
// import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { DeWidgets } from 'components/de-widgets'
import { VideoPlayer } from 'components/videoplayer'

// TODO Set the correct article ID here
const ARTICLE_ID = '836320074338'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical very fitted segment'>
        <div className='topCover'>
          <div className='ui text container header'>
            <div className='ui header'>
              <div className='titleContainer'>
                {' '}
                <h1>
                  Deutschland&nbsp;wählt <br />
                  <div className='deFlagWrapper'>
                    <div className='black' />
                    <div className='red' />
                    <div className='yellow' />
                  </div>
                </h1>
                {/* <div className='deFlagWrapper'>
                  <div className='black' />
                  <div className='red' />
                  <div className='yellow' />
                </div> */}
                <div className='year'>2021</div>
              </div>

              <h2>
                Alle Ergebnisse, Sitzverteilungen und mögliche Koalitionen. Der
                Überblick zur Bundestagswahl in Grafiken.
              </h2>
            </div>
          </div>
          <div className='ui container'>
            <div className='ui header' />
          </div>
        </div>
        <div className='bottomCover'>
          <Image
            file={require('../../images/reichstag.svg')}
            className='cbImage reichstag'
          />
          <div className='gradientBottom' />
        </div>
      </header>

      <div
        className='ui vertical fitted segment'
        style={{ paddingTop: 'calc(0vw + 1em)' }}
      >
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Marc Brupbacher, Patrick Vögeli</div>
            <div className='ta updated'>
              Grafiken werden regelmässig aktualisiert
            </div>
          </div>
          {/* <div className='ta text'>
            <p>
              Nach 16 Jahren im Amt tritt Bundeskanzlerin Angela Merkel (CDU)
              nicht mehr an. Somit wird Deutschland nach der Wahl eine neue
              Kanzlerin oder einen neuen Kanzler bekommen: Annalena Baerbock,
              Armin Laschet oder Olaf Scholz.
            </p>

            <VideoPlayer
              mp4={require('./videos/merkel.mp4')}
              mp4Mobile={require('./videos/merkel_mobile.mp4')}
              webm={require('./videos/merkel.webm')}
              webmMobile={require('./videos/merkel_mobile.webm')}
              poster={require('./videos/merkel.jpg')}
              trackingID='16 Jahre Merkel'
            />
            <p>
              In Deutschland wird das Regierungsoberhaupt nicht direkt gewählt.
              Meinungsforschungsinstitute fragen trotzdem regelmässig, für wen
              sich die Bürger bei einer Direktwahl entscheiden würden.
            </p>
            <p>
              Mehrere Meinungsforschungsinstitute ermitteln mit der
              Sonntagsfrage regelmässig bei Wählerinnen und Wählern, welche
              Partei sie wählen würden, wenn am nächsten Sonntag Bundestagswahl
              wäre. Nachfolgend sehen Sie die aktuellsten Umfrageresultate.{' '}
            </p>
            <div className='hint'>
              <i className='icon hand pointer outline' />
              Sie können oben an den Grafiken jederzeit zwischen den führenden
              Instituten hin- und herwechseln.
            </div>
          </div> */}
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='graphicTitle'>Stimmenanteile</h4>
            {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
            <DeWidgets chartType='stimmenanteileQuer' />
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui container'>
          <div className='ui grid stackable'>
            <div className='eight wide column'>
              <div className='ta text'>
                <h4 className='graphicTitle'>Sitzverteilung</h4>
                {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
                <DeWidgets chartType='sitzverteilung' />
              </div>
            </div>
            <div className='eight wide column'>
              <div className='ta text'>
                <h4 className='graphicTitle'>Koalitionsrechner</h4>
                {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
                <DeWidgets chartType='koalitionsrechner' />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='ui vertical fitted segment'>
        <div className='ui container'>
          <div className='ui grid stackable'>
            <div className='eight wide column'>
              <div className='ta text'>
                <h4 className='graphicTitle'>Wählerwanderung</h4>

                <DeWidgets chartType='waehlerwanderung' />
              </div>
            </div>
            <div className='eight wide column'>
              <div className='ta text'>
                <h4 className='graphicTitle'>Parteihochburgen</h4>

                <DeWidgets chartType='parteihochburgen' />
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='graphicTitle'>Wahlkreisergebnisse</h4>
            <DeWidgets chartType='wahlkreisergebnisse' />
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='graphicTitle'>Wählerwanderung</h4>
            <DeWidgets chartType='waehlerwanderung' />
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='graphicTitle'>Parteihochburgen</h4>
            <DeWidgets chartType='parteihochburgen' />
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={['Wie nützlich finden Sie diese Resultate-Übersicht?']}
        credits={[
          ['Umsetzung', 'Patrick Vögeli'],
          ['Grafiken', 'dpa-ElectionsLive']
        ]}
      />
    </div>
  )
}
